class PaymentRequest {
    static async init() {
        console.log("PaymentRequest init");
        const btn = document.querySelector('.initiatepayment');
        const btnInactiveMessage = document.querySelector('.buttonInactiveMessage');
        if(btn){
            btn.addEventListener('click', async (event) => {
                event.target.disabled = true;
                if (btnInactiveMessage) {
                    btnInactiveMessage.classList.remove('hidden');
                }
                try{
                    event.preventDefault();
                    const inp = document.querySelector('#paymentamount');
                    var val = +inp.value;
                    if (!isNaN(val) && val > 0) {
                        const data = {
                            customerNo: baseCustomerReportData.customerNo,
                            customerKey: baseCustomerReportData.customerKey,
                            shopifyUserId: baseCustomerReportData.shopifyUserId,
                            location: baseCustomerReportData.location,
                            company: baseCustomerReportData.company,
                            amount: val
                        };
                        //
                        const url = `https://${baseUrl}/api/WorldwideTradeAcceptPayments`;
                        var result = await fetch(url, {
                            method: "POST",
                            headers: {
                                'Content-Type': 'application/json',
                              },
                            body: JSON.stringify(data),
                        })
                        .then(response => response.text())
                        .then(result => JSON.parse(result))
                        .catch(error => {
                            alert('There was an error while generating payment link. Please refresh the page and try again.')
                            console.log('error', error);
                            event.target.disabled = false;

                        });
                        if(result && result.isSuccess && result.redirectUrl){
                            window.location = result.redirectUrl;
                        }

                    } else {
                        alert(`${inp.value} is not a valid amount.`);
                    }
                }
                catch(e){
                    alert('There was an error while generating payment link. Please refresh the page and try again.')
                }
                finally{
                    //event.target.disabled = false;
                    //if (btnInactiveMessage) {
                    //    btnInactiveMessage.classList.add('hidden');
                    //}
                }
            });
        }

        this.waitForSpaklayer(async () => {
            const data = await this.getAccountBalance();
            this.updateUi(data);
        }, 100);

    }

    static updateUi(data) {
        const balanceText = document.querySelector('.balance_text');
        if (balanceText) {
            balanceText.innerHTML = this.currencyFormat(data.balance, data.currencyCode);
        }
        const creditLimitText = document.querySelector('.credit_limit_text');
        if (creditLimitText) {
            creditLimitText.innerHTML = this.currencyFormat(data.creditLimit, data.currencyCode);
        }
    }

    static currencyFormat(total, currency){
        let totalAmt = total ?? 0;
        switch (currency.toLowerCase()) {
            case "gbp": {
                return "£" + totalAmt.toFixed(2);
            }
            case "usd": {
                return "$" + totalAmt.toFixed(2);
            }
            case "eur": {
                return "€" + totalAmt.toFixed(2);
            }
            case "aud": {
                return "A$" + totalAmt.toFixed(2);
            }
            default: return "";
        }
    }

    static waitForSpaklayer(method, retryCount) {
        if (!window) return;
        if (window.spark) {
            method();
        } else {
            if (retryCount > 0) {
                setTimeout(() => this.waitForSpaklayer(method, --retryCount), 300);
            } else {
                console.error("Failed to find Spark layer");
            }
        }
    }

    static async getAccountBalance() {
        const query = `
        query($impersonatingCustomerId: String) {
	        loggedInCustomer(impersonatingCustomerId: $impersonatingCustomerId) {
	          paymentOnAccount {
		        balance
		        creditLimit
		        netTerms
		        currencyCode
	          }
	        }
        }
        `;
        const variable = {
            "impersonatingCustomerId": null
        };

        const response = await spark.fetch(query, variable);
        const json = await response.json();
        const balanceData = json;
        return balanceData?.data?.loggedInCustomer?.paymentOnAccount;
    }
}

(() => PaymentRequest.init())();